/* UF — force autoplay on muted product/hero videos (iOS kick) */
(function () {
  function kick(v) {
    if (!v) return;
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true; v.setAttribute('playsinline', '');
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  }
  function all() {
    document.querySelectorAll('.uf4 video[autoplay], .u2hero video, .uf2-hero-fullbleed video').forEach(kick);
  }
  all();
  window.addEventListener('load', all);
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) all(); });
  var once = function(){ all(); document.removeEventListener('touchstart', once); document.removeEventListener('click', once); };
  document.addEventListener('touchstart', once, { passive: true });
  document.addEventListener('click', once);
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) kick(e.target); }); }, { threshold: 0.2 });
    document.querySelectorAll('.uf4 video[autoplay], .u2hero video').forEach(function(v){ io.observe(v); });
  }
})();

/* UF — PDP gallery: tap left/right edge, swipe, or mouse click-drag to change
   slide (loops). Works with the uf4-product-v12 gallery (.gmain fade slides). */
(function(){
  function init(){
    document.querySelectorAll('.uf4-pgrid .gal').forEach(function(gal){
      if(gal.dataset.ufnav) return;
      var main=gal.querySelector('.gmain'); if(!main) return;
      var items=[].slice.call(main.querySelectorAll('[data-gitem]'));
      if(items.length<2) return;
      gal.dataset.ufnav='1';
      function visible(){return items.filter(function(g){return getComputedStyle(g).display!=='none';});}
      function current(){var v=visible();for(var i=0;i<v.length;i++){if(v[i].classList.contains('on'))return i;}return 0;}
      function activate(g){
        var idx=g.dataset.gitem;
        var t=gal.querySelector('[data-gthumb="'+idx+'"]');
        if(t){t.click();return;}
        items.forEach(function(x){var on=x===g;x.classList.toggle('on',on);var vd=x.querySelector('video');if(vd){if(on){vd.muted=true;vd.play().catch(function(){});}else{vd.pause();}}});
      }
      function step(d){var v=visible();if(v.length<2)return;var i=(current()+d+v.length)%v.length;activate(v[i]);}
      ['prev','next'].forEach(function(k){
        var b=document.createElement('button');
        b.type='button';b.className='gnav '+k;
        b.setAttribute('aria-label',k==='prev'?'Previous image':'Next image');
        b.addEventListener('click',function(e){e.stopPropagation();step(k==='prev'?-1:1);});
        main.appendChild(b);
      });
      var sx=0,sy=0,st=0;
      main.addEventListener('touchstart',function(e){var t=e.touches[0];sx=t.clientX;sy=t.clientY;st=Date.now();},{passive:true});
      main.addEventListener('touchend',function(e){
        var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;
        if(Date.now()-st>600)return;
        if(Math.abs(dx)>44&&Math.abs(dx)>Math.abs(dy)*1.5){step(dx<0?1:-1);}
      },{passive:true});
      var mdown=false,msx=0,mused=false;
      main.addEventListener('mousedown',function(e){
        if(e.button!==0)return;
        mdown=true;mused=false;msx=e.clientX;
        e.preventDefault();
      });
      main.addEventListener('mouseup',function(e){
        if(!mdown)return;mdown=false;
        var dx=e.clientX-msx;
        if(Math.abs(dx)>50){var btn=gal.querySelector(dx<0?'.gnav.next':'.gnav.prev');if(btn)btn.click();mused=true;}
      });
      main.addEventListener('mouseleave',function(){mdown=false;});
      main.addEventListener('click',function(e){if(mused){e.stopPropagation();e.preventDefault();mused=false;}},true);
      main.addEventListener('dragstart',function(e){e.preventDefault();});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

/* UF — horizontal card rails: click-drag (desktop) + committed swipe, WITH
   LOOP — swiping forward on the last card wraps to the first (and back from
   the first wraps to the last). Touch scrolling stays 100% native — we only
   step in AFTER the scroll settles: if a ≥40px swipe bounced back or hit the
   end, we carry it on (or round). ONE shared window listener pair (passive). */
(function(){
  var SEL='.jrail,.irail,.b-rail,.landrail,.uf4-rail,.qcar2 .qwrap2';
  var active=null,dragged=false,sx=0,sl=0;
  function cards(rail){return [].slice.call(rail.children).filter(function(c){return c.nodeType===1&&c.offsetWidth>0;});}
  function offs(rail){
    var rb=rail.getBoundingClientRect(),x=rail.scrollLeft;
    return cards(rail).map(function(c){return x+(c.getBoundingClientRect().left-rb.left);});
  }
  function nearest(o,x){var b=0,bd=1e9;for(var k=0;k<o.length;k++){var d=Math.abs(o[k]-x);if(d<bd){bd=d;b=k;}}return b;}
  function clampT(rail,v){return Math.max(0,Math.min(v,rail.scrollWidth-rail.clientWidth));}
  function commit(rail,startScroll,dx){
    var o=offs(rail),n=o.length,from=nearest(o,startScroll),to=from;
    if(dx<=-40)to=from+1;else if(dx>=40)to=from-1;else return null;
    if(to>=n)to=0;        /* loop forward → back to first */
    if(to<0)to=n-1;       /* loop back → round to last */
    if(to===from)return null;
    return clampT(rail,o[to]);
  }
  window.addEventListener('mousemove',function(e){
    if(!active)return;
    var dx=e.clientX-sx;
    if(!dragged&&Math.abs(dx)>4){
      dragged=true;active.style.cursor='grabbing';
      document.body.style.userSelect='none';
      active.style.scrollSnapType='none';
    }
    if(dragged)active.scrollLeft=sl-dx;
  },{passive:true});
  window.addEventListener('mouseup',function(e){
    if(!active)return;
    var rail=active;active=null;
    rail.style.cursor='grab';
    document.body.style.userSelect='';
    if(dragged){
      var target=commit(rail,sl,e.clientX-sx);
      if(target===null){var o=offs(rail);target=clampT(rail,o[nearest(o,rail.scrollLeft)]);}
      rail.scrollTo({left:target,behavior:'smooth'});
      var before=rail.scrollLeft;
      setTimeout(function(){if(Math.abs(target-rail.scrollLeft)>8&&Math.abs(rail.scrollLeft-before)<8){rail.scrollLeft=target;}},280);
      setTimeout(function(){rail.style.scrollSnapType='';},650);
    }
  },{passive:true});
  function enhance(rail){
    if(rail.dataset.ufdrag)return;rail.dataset.ufdrag='1';
    rail.style.cursor='grab';
    rail.addEventListener('mousedown',function(e){
      if(e.button!==0)return;
      active=rail;dragged=false;sx=e.clientX;sl=rail.scrollLeft;
      e.preventDefault(); /* stop text selection + native image drag */
    });
    var tx=null,tsl=0;
    rail.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;tsl=rail.scrollLeft;},{passive:true});
    rail.addEventListener('touchend',function(e){
      if(tx===null)return;
      var dx=e.changedTouches[0].clientX-tx,startScroll=tsl;tx=null;
      if(Math.abs(dx)<40)return;
      var last=-1,ticks=0;
      clearInterval(rail._ufiv);
      rail._ufiv=setInterval(function(){
        var x=rail.scrollLeft;
        if(Math.abs(x-last)<1){
          clearInterval(rail._ufiv);
          var o=offs(rail);
          if(nearest(o,x)===nearest(o,startScroll)){
            var t=commit(rail,startScroll,dx);
            if(t!==null)rail.scrollTo({left:t,behavior:'smooth'});
          }
        }
        last=x;
        if(++ticks>16)clearInterval(rail._ufiv);
      },90);
    },{passive:true});
    rail.addEventListener('touchcancel',function(){tx=null;clearInterval(rail._ufiv);},{passive:true});
    rail.addEventListener('click',function(e){
      if(dragged){e.preventDefault();e.stopPropagation();dragged=false;return;}
      var kid=e.target;while(kid&&kid.parentElement!==rail)kid=kid.parentElement;
      if(!kid)return;
      var rb=rail.getBoundingClientRect(),kb=kid.getBoundingClientRect();
      if(kb.left<rb.left-6||kb.right>rb.right+6){
        e.preventDefault();e.stopPropagation();
        kid.scrollIntoView({behavior:'smooth',inline:'nearest',block:'nearest'});
      }
    },true);
    rail.addEventListener('dragstart',function(e){e.preventDefault();});
  }
  function initAll(){document.querySelectorAll(SEL).forEach(enhance);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll);}else{initAll();}
  document.addEventListener('shopify:section:load',initAll);
})();

/* UF — product-block testimonials: scroll-synced dots for the peek rail
   (the section's own fade-carousel dots are hidden by custom.css). */
(function(){
  function init(){
    document.querySelectorAll('[data-qcar]').forEach(function(car){
      if(car.dataset.ufq)return;
      var wrap=car.querySelector('.qwrap2');if(!wrap)return;
      var cards=[].slice.call(wrap.querySelectorAll('.qc2'));
      if(cards.length<2)return;
      car.dataset.ufq='1';
      var dots=document.createElement('div');dots.className='ufqdots';
      function offOf(c){var rb=wrap.getBoundingClientRect();return wrap.scrollLeft+(c.getBoundingClientRect().left-rb.left);}
      cards.forEach(function(c,k){
        var b=document.createElement('button');b.type='button';if(k===0)b.className='on';
        b.setAttribute('aria-label','Review '+(k+1));
        b.addEventListener('click',function(){wrap.scrollTo({left:offOf(c),behavior:'smooth'});});
        dots.appendChild(b);
      });
      car.appendChild(dots);
      function sync(){
        var x=wrap.scrollLeft,best=0,bd=1e9;
        cards.forEach(function(c,k){var d=Math.abs(offOf(c)-x);if(d<bd){bd=d;best=k;}});
        if(x>=wrap.scrollWidth-wrap.clientWidth-4)best=cards.length-1;
        dots.querySelectorAll('button').forEach(function(d,k){d.classList.toggle('on',k===best);});
      }
      wrap.addEventListener('scroll',function(){clearTimeout(wrap._ufqs);wrap._ufqs=setTimeout(sync,100);},{passive:true});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

/* UF — discount-link override.
   Problem: /discount/CODE links only set a cookie; if the cart already has a
   discount applied (earlier link or popup code), checkout keeps the OLD code.
   Fix: when a discount link/param brings a code in, force-apply it to the
   cart via the AJAX Cart API — which REPLACES all existing discount codes.
   Newest code always wins. */
(function(){
  function getCode(){
    var m=location.search.match(/[?&](?:discount|dt)=([^&]+)/i);
    if(m)return decodeURIComponent(m[1]);
    var c=document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return c?decodeURIComponent(c[1]):null;
  }
  var code=getCode();
  if(!code)return;
  var KEY='uf_disc_applied';
  try{if(sessionStorage.getItem(KEY)===code)return;}catch(e){}
  fetch('/cart/update.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({discount:code})
  }).then(function(r){
    if(r.ok){try{sessionStorage.setItem(KEY,code);}catch(e){}}
  }).catch(function(){});
})();

/* UF — consent persistence guard.
   Some mobile browsers (iOS Chrome/Safari WebKit) don't reliably persist the
   Shopify consent cookie, so the banner reappears on every load even after
   accepting. Mirror the visitor's collected consent into localStorage and
   silently re-apply it on load before the banner can render. */
(function(){
  var KEY = 'uf_consent_v1';
  function save(c){ try{ localStorage.setItem(KEY, JSON.stringify(c)); }catch(e){} }
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY) || 'null'); }catch(e){ return null; } }

  document.addEventListener('visitorConsentCollected', function(e){
    var d = e && e.detail ? e.detail : {};
    save({
      analytics:   d.analyticsAllowed   !== undefined ? !!d.analyticsAllowed   : true,
      marketing:   d.marketingAllowed   !== undefined ? !!d.marketingAllowed   : true,
      preferences: d.preferencesAllowed !== undefined ? !!d.preferencesAllowed : true,
      sale_of_data: d.saleOfDataAllowed !== undefined ? !!d.saleOfDataAllowed  : true
    });
  });
  document.addEventListener('click', function(e){
    var t = e.target;
    if(t && t.closest && t.closest('#shopify-pc__banner__btn-accept')){
      save({ analytics:true, marketing:true, preferences:true, sale_of_data:true });
    }
  }, true);

  var stored = read();
  if(!stored) return;

  function apply(){
    try{
      var api = window.Shopify && Shopify.customerPrivacy;
      if(!api || !api.setTrackingConsent) return;
      api.setTrackingConsent({
        analytics: !!stored.analytics,
        marketing: !!stored.marketing,
        preferences: !!stored.preferences,
        sale_of_data: !!stored.sale_of_data
      }, function(){});
      var b = document.getElementById('shopify-pc__banner');
      if(b) b.remove();
    }catch(e){}
  }
  if(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent){
    apply();
  } else if(window.Shopify && Shopify.loadFeatures){
    Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], function(err){ if(!err) apply(); });
  } else {
    document.addEventListener('DOMContentLoaded', apply);
  }
  if('MutationObserver' in window){
    new MutationObserver(function(){
      var b = document.getElementById('shopify-pc__banner');
      if(b && read()) b.remove();
    }).observe(document.documentElement, { childList:true, subtree:true });
  }
})();